import { createContext, useContext } from 'react';
import RegistrationTypes from '../constants/RegistrationTypes';
import useAppMetadata from '../services/useAppMetadata';

/**
 * @typedef {object} AppCallbackUrls
 * @param {string} notification_callback_urls
 * @param {string} user_attribute_callback_url
 * @param {string} check_switch_callback_url
 */

/**
 * @typedef AppMetadata
 * @param {string} client_id
 * @param {string} app_name
 * @param {string} app_short_name
 * @param {string} app_dns
 * @param {string} app_home_url
 * @param {string} app_svg_logo_url
 * @param {string} app_png_logo_url
 * @param {AppCallbackUrls} app_callback_urls
 * @param {string[]} oauth_redirect_urls
 * @param {boolean} expose_tenant_in_portal
 * @param {string} tenant_list_url
 * @param {string} registration_type registrations for Vault users, non-Vault users or VeevaID
 * @param {boolean} use_interstitial bypass the confirmation page in the registration flow
 */

/**
 * @returns {AppMetadata}
 */
const AppMetadataContext = createContext({
    appMetadata: {},
    isNonVaultApp: false,
});

export const useAppMetadataContext = () => useContext(AppMetadataContext) ?? {};

const AppMetadataContextWrapper = ({ children }) => {
    const appMetadata = useAppMetadata();
    const isNonVaultApp =
        appMetadata?.registration_type === RegistrationTypes.NON_VAULT_APP && appMetadata?.app_name;

    const context = { appMetadata, isNonVaultApp };

    return <AppMetadataContext.Provider value={context}>{children}</AppMetadataContext.Provider>;
};

export default AppMetadataContextWrapper;
